<main>
	<h1>I@D Leads Dashboard</h1>
{#if !authenticated}
	<div class="container">
		<div id="login-form" class="col-md-4 offset-md-4">
		  <div class="form-group">
		    <input placeholder="Email"  type="email" bind:value={email} class="form-control" id="InputEmail1" aria-describedby="emailHelp">
		  </div>
		  <div class="form-group">
		    <input placeholder="Password" type="password" bind:value={password} class="form-control" id="InputPassword1">
		  </div>
		  <button type="submit" class="btn btn-primary" on:click="{login}">Login</button>
		</div>
	</div>
{/if}
{#if authenticated}
	<Leads/>
{/if}
</main>


<script>
	import Leads from './Leads.svelte'
	import { axiosInstance } from './api/axiosInstance'
	import * as store from './store'

	let email;
	let password;
	
	let authenticated, accessToken;
	
	store.authenticated.subscribe(value => {
		authenticated = value;
	});

	store.accessToken.subscribe(value => {
		accessToken = value;
	});


	if(hasTokenInLocalStorage())
		rehydrateToken()


	function login(){
		axiosInstance.post("authentication",{
			email:email,
			password:password,
			strategy:"partnerLogin"
		}).then(function(response){
			if(response.data.accessToken != null){
				store.setValue('authenticated',true)
				store.setValue('accessToken',response.data.accessToken)
			}
		}).catch(function(err){
			console.log(err)
		})
	}


	function hasTokenInLocalStorage(){
		if(window.localStorage.getItem("accessToken") != null)
			return true

		return false
	}

	function rehydrateToken(){
		const token = window.localStorage.getItem("accessToken");
		store.setValue('authenticated',true)
		store.setValue('accessToken',token)

	}
</script>

<style>
	main {
		text-align: center;
		padding: 1em;
		max-width: 240px;
		margin: 0 auto;
	}

	#login-form{
		margin-top:100px;
	}

	h1 {
		color: #ff3e00;
		text-transform: uppercase;
		font-size: 4em;
		font-weight: 100;
	}

	@media (min-width: 640px) {
		main {
			max-width: none;
		}
	}
</style>